// Components - UI
import ReviewMood from '@/components/ui/ReviewMood/ReviewMood.vue';
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import WashroomIcon from '@/components/ui/WashroomIcon/WashroomIcon.vue';
import WashroomsCount from '@/components/ui/WashroomsCount/WashroomsCount.vue';
import IssueStatusIcons from '@/components/ui/IssueStatusIcons/IssueStatusIcons.vue';
import SubscriptionLevel from '@/components/ui/SubscriptionLevel/SubscriptionLevel.vue';

// Services
import IssuesService from '@/services/IssuesService.js';
import ReviewsService from '@/services/ReviewsService.js';
import WashroomsService from '@/services/WashroomsService.js';
import RetailersService from '@/services/RetailersService.js';
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';

// Mixins
import StaggerEntranceTransition from '@/components/mixins/StaggerEntranceTransition/StaggerEntranceTransition.vue';

// EventBus
import { EventBus } from '@/EventBus.js';

// Vendor
import moment from 'moment';

export default {

  name: 'reviews',

  mixins: [
    StaggerEntranceTransition
  ],

  components: {
    ReviewMood,
    ReviewStars,
    WashroomIcon,
    WashroomsCount,
    IssueStatusIcons,
    SubscriptionLevel
  },

  data: function() {
    return {
      pageTitle: null,
      reviews: [],
      retailer: null,
      searchTerm: null,
      showSearch: false,
      onlyOpen: false,
      userGroup: localStorage.getItem('userGroup')
    }
  },

  created: function() {
    if(localStorage.getItem('userGroup') == 'service-providers') {
      this.onlyOpen = true;
    }

    this.init();
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    init: function() {
      // Reset component data
      this.reviews = [];
      this.retailer = null;

      let filter = null;

      // If we have a route parameter with a retailer ID
      if(this.$route.params.retailerId) {
        RetailersService.getById(this.$route.params.retailerId)
          .then((res) => {
            this.pageTitle = res.data.name;
          })
          .catch((err) => {});

        filter = {
          retailer: this.$route.params.retailerId
        };

        this.getReviews(filter);
      }
      // If we have a route parameter with a washroom ID
      else if(this.$route.params.washroomId) {
        WashroomsService.getById(this.$route.params.washroomId)
          .then((res) => {
            this.pageTitle = res.data.name;
          })
          .catch((err) => {});

        filter = {
          washroom: this.$route.params.washroomId
        };

        this.getReviews(filter);
      }
      // If we have a route parameter with a multisite ID
      else if(this.$route.params.multisiteId) {
        MultisitesService.getById(this.$route.params.multisiteId)
          .then((res) => {
            this.pageTitle = res.data.name;
          })
          .catch((err) => {});

        RetailersService.getAll({multiSite: this.$route.params.multisiteId})
          .then((res) => {
            filter = []

            for (let i in res.data) {
              filter.push({retailer: res.data[i].id});
            }

            this.getReviews(filter, 'or');
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
      }
      // If we are logged in as a retailer
      else if(localStorage.getItem('userGroup') == 'retailers') {
        filter = {
          retailer: localStorage.getItem('parentId') // In this case 'parentID' is the logged in retailer's id
        };

        this.getReviews(filter);
      }
      // If we are logged in as a multi-site retailer
      else if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        RetailersService.getAll({multiSite: localStorage.getItem('parentId') }) // In this case 'parentID' is the logged in multi-site-retailer's id
          .then((res) => {
            filter = [];

            for (let i in res.data) {
              filter.push({retailer: res.data[i].id});
            }

            if(filter.length > 0) {
              this.getReviews(filter, 'or');
            }
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
      }
      // If we are logged in as a service provider
      else if(localStorage.getItem('userGroup') == 'service-providers') { // If we are logged in as a service provider
        ServiceRelationshipsService.getAll({serviceProvider: localStorage.getItem('parentId'), status: 'approved'})
          .then((res) => {
            let retailerIds = [];
            let filter = [];
            let filterMode = 'or';

            // Get DISTINCT ids of retailers that this SP services
            for(let i in res.data) {
              if(res.data[i].retailer && res.data[i].retailer.id) {
                if(retailerIds.indexOf(res.data[i].retailer.id) == -1) {
                  retailerIds.push(res.data[i].retailer.id);
                  filter.push({retailer: res.data[i].retailer.id});
                }
              }
            }

            if(filter.length > 0) {
              this.getReviews(filter, filterMode);
            }
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
      }
      // Not logged in a filterable user type
      else {
        this.getReviews();
      }

      if (filter && filter.retailer) {
        RetailersService.getById(filter.retailer)
          .then((res) => {
            this.retailer = res.data;
          });
      }
    },

    getReviews: function(filter, filterMode) {
      ReviewsService.getAll(filter, filterMode, null, 'createdAt DESC')
        .then((res) => {
          this.reviews = res.data;

          for (let i in this.reviews) {
            // Get filtered issues for service provider
            if(localStorage.getItem('userGroup') == 'service-providers') {
              let issueFilters = {
                review: this.reviews[i].id,
                serviceProvider: localStorage.getItem('parentId'),
                status: ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied']
              };

              // IssuesService.getAll(issueFilters)
              // .then((res) => {
              //   this.reviews[i].issues = res.data;
              // });
            }
          }

        });
    },

    filterWashrooms: function(review) {
      let washroomId = review.washroom;

      if(review.retailer && review.retailer.washrooms) {
        let filteredWashrooms = review.retailer.washrooms.filter((item) => item.id == washroomId);

        if(filteredWashrooms.length == 1) {
          return filteredWashrooms[0];
        }

        return {
          humanId: ''
        };
      }

      return {
        humanId: ''
      };
    },

    goToReview: function(id) {
      this.$router.push('/reviews/' + id);
    },

    openSearch: function() {
      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function() {
      this.searchTerm = null;
      this.showSearch = false;
    },

    filterServiceProviderIssues: function(issues) {
      let serviceProviderId = localStorage.getItem('parentId');

      return issues.filter((i) => {
        if(i.serviceProvider == serviceProviderId || i.serviceProvider == null) {
          return true;
        }

        return false;
      })

    }
  },

  computed: {
    search: function() {
      // Filter by search criteria
      if(this.searchTerm && this.searchTerm.trim().length > 0 || (this.onlyOpen && this.onlyOpen === true)) {
        let results = null;

        if(this.searchTerm && this.searchTerm.trim().length > 0) {
          results = this.reviews.filter((r) => {
            if (
              r.retailer.name.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1
              || this.filterWashrooms(r).humanId.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1
              || r.retailer.address.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1
              || r.retailer.city.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1
              || r.retailer.postcode.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1
              || r.washroom.humanId.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1
              || moment(r.createdAt).format('D.M.Y').indexOf(this.searchTerm.toLowerCase().trim()) > -1
            ) {
              return true;
            }

            return false;
          });
        }

        let issueFilter = (r) => {
          let openIssues = r.issues.filter((i) => {
            if(localStorage.getItem('userGroup') == 'service-providers') { // If we are logged in as a service provider
              let serviceProviderId = localStorage.getItem('parentId');

              let openIssueStatus = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

              if((i.serviceProvider == serviceProviderId || i.serviceProvider == null) && openIssueStatus.indexOf(i.status) > -1) {
                return true;
              }
            }
            else {
              if(openIssueStatus.indexOf(i.status) > -1) {
                return true;
              }
            }

            return false;
          })

          if(openIssues.length > 0) {
            return true;
          }

          return false;
        };

        // Filter by open issues
        if(this.onlyOpen && this.onlyOpen === true) {
          // Filter issues on review search results
          if(this.searchTerm && this.searchTerm.trim().length > 0) {
            results = results.filter(issueFilter);
          }
          // Filter issues on all reviews
          else {
            results = this.reviews.filter(issueFilter);
          }
        }

        return results;
      }
      else {
        return this.reviews;
      }
    }
  },

  watch: {
    '$route' (to, from) {
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Reviews/Reviews.js